import { http8010 } from "config/http8010"


export const getConfigData = async (source: string) => {
    let url;
    if (source === "SFTP") {
        url = `get_source_wise_configrations?source=sftp_doc`
    } else {
        url = `get_source_wise_configrations?connector_name=${source}`
    }
    try {
        const res: any = await http8010.get(url)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getConfigDataByID = async (id: string) => {
    try {
        const res: any = await http8010.get(`get_configuration_data_by_id?objectid=${id}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getConnectorsDropdownData = async () => {
    try {
        const res: any = await http8010.get(`get_key_values_of_connectors`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getConnectorsKeysData = async (data: any) => {
    try {
        const res: any = await http8010.get(`get_key_values_of_connectors?source_name=${data}`)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getDataForConnectors = async (connector_name: string, client_name: string, from_date: string, to_date: string, code: any, fileType: string) => {
    try {
        if (fileType !== "") {
            const res: any = await http8010.get(code === ""
                ? `get_data_for_connectors?connector_name=${connector_name}&client_name=${client_name}&start_date=${from_date}&end_date=${to_date}&file_type=${fileType}`
                : `get_data_for_connectors?connector_name=${connector_name}&client_name=${client_name}&start_date=${from_date}&end_date=${to_date}&file_status=${code}&file_type=${fileType}`)
            return { result: res?.data }
        } else {
            const res: any = await http8010.get(code === ""
                ? `get_data_for_connectors?connector_name=${connector_name}&client_name=${client_name}&start_date=${from_date}&end_date=${to_date}`
                : `get_data_for_connectors?connector_name=${connector_name}&client_name=${client_name}&start_date=${from_date}&end_date=${to_date}&file_status=${code}`)
            return { result: res?.data }
        }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveConfig = async (data: object) => {
    try {
        const res: any = await http8010.post('save_sftp', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const loginConfig = async (data: object) => {
    try {
        const res: any = await http8010.post('sftp_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveSharepoint = async (data: object) => {
    try {
        const res: any = await http8010.post('save_sharepoint', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const sharepointLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('sharepoint_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveConfluence = async (data: object) => {
    try {
        const res: any = await http8010.post('save_confluence', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const confluenceLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('confluence_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveAmazons3 = async (data: object) => {
    try {
        const res: any = await http8010.post('save_amazons3', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const amazons3Login = async (data: object) => {
    try {
        const res: any = await http8010.post('amazons3_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveDropbox = async (data: object) => {
    try {
        const res: any = await http8010.post('save_dropbox', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const dropboxLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('dropbox_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveSalesforce = async (data: object) => {
    try {
        const res: any = await http8010.post('save_salesforce', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const salesforceLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('salesforce_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveJira = async (data: object) => {
    try {
        const res: any = await http8010.post('save_jira', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const jiraLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('jira_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveServicenow = async (data: object) => {
    try {
        const res: any = await http8010.post('save_servicenow', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const servicenowLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('servicenow_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveFreshservice = async (data: object) => {
    try {
        const res: any = await http8010.post('save_freshservice', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const freshserviceLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('freshservice_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveZendesk = async (data: object) => {
    try {
        const res: any = await http8010.post('save_zendesk', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const zendeskLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('zendesk_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveGmail = async (data: object) => {
    try {
        const res: any = await http8010.post('save_gmail', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const gmailLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('gmail_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveAsana = async (data: object) => {
    try {
        const res: any = await http8010.post('save_asana', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const asanaLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('asana_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const saveConnectors = async (data: object) => {
    try {
        const res: any = await http8010.post('save_connectors', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const azureBlobLogin = async (data: object) => {
    try {
        const res: any = await http8010.post('azure_blob_login', data);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}